'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSOLE = exports.CONSOLE = 'CONSOLE';
var FILE = exports.FILE = 'FILE';
var CORDOVA_FILE = exports.CORDOVA_FILE = 'CORDOVA_FILE';
var APP_INSIGHTS = exports.APP_INSIGHTS = 'APP_INSIGHTS';
var DYNATRACE = exports.DYNATRACE = 'DYNATRACE';

var types = exports.types = {
  CONSOLE: CONSOLE,
  FILE: FILE,
  CORDOVA_FILE: CORDOVA_FILE,
  APP_INSIGHTS: APP_INSIGHTS
};

exports.default = types;